import { styled } from '@mui/material/styles'
import TableHead from '@mui/material/TableHead'

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'light' ? theme.palette.secondary.main : theme.palette.action.selected,
  '& .MuiTableCell-root': {
    color: 'white'
  }
}))

export default StyledTableHead
